import { publicAxios } from "../lib/axios";
export default {
  namespaced: true,
  state: {
    licenca: [],
    empresas: [],
    fakeID: 4
  },
  mutations: {
    carregarLicenca(state) {
      try {
        publicAxios
          .get("/licencas")
          .then(response => (state.licenca = response.data));

        return Promise.resolve(true);
      } catch (err) {
        return Promise.reject(err);
      }
    },
    gravarLicenca(state) {
      state.fakeID++;
    },
    buscarLicenca(state, response) {
      state.licenca = response;
    },
    carregarEmpresas(state, response) {
      var aDados = [];

      for (var i = 0; i < response.length; i++) {
        aDados[i] = {
          value: response[i].id,
          text: response[i].descricao
        };
      }

      state.empresas = aDados;
    }
  },
  actions: {
    listar(context) {
      context.commit("carregarLicenca");
    },
    buscar(context, aFiltro) {
      try {
        var filtro = aFiltro.filtro ? aFiltro.filtro : "";
        var valor = aFiltro.valor ? aFiltro.valor : "";

        publicAxios
          .get("/licencas?" + filtro + "=" + valor)
          .then(response => context.commit("buscarLicenca", response.data));

        return Promise.resolve(true);
      } catch (err) {
        return Promise.reject(err);
      }
    },
    gravar(context, LicencaInfo) {
      try {
        var id = LicencaInfo.id;

        if (id == "") {
          var infoNovo = {
            id: this.state.fakeID,
            descricao: LicencaInfo.descricao,
            codigo: LicencaInfo.codigo,
            id_empresa: LicencaInfo.id_empresa,
            actions: {
              canView: true,
              canEdit: true,
              canDelete: true
            }
          };
          publicAxios.post("/licencas", infoNovo);
          context.commit("gravarLicenca");
        } else {
          var infoAltera = {
            descricao: LicencaInfo.descricao,
            codigo: LicencaInfo.codigo,
            id_empresa: LicencaInfo.id_empresa,
            actions: {
              canView: true,
              canEdit: true,
              canDelete: true
            }
          };
          publicAxios.put("/licencas/" + id, infoAltera);
          context.commit("gravarLicenca");
        }

        return Promise.resolve(true);
      } catch (err) {
        return Promise.reject(err);
      }
    },
    deletar(context, id) {
      try {
        publicAxios.delete("/licencas/" + id.id);
        return Promise.resolve(true);
      } catch (err) {
        return Promise.reject(err);
      }
    },
    async carregarLicenca(context, id) {
      try {
        const response = publicAxios.get("/licencas?id=" + id.id);
        return Promise.resolve(response);
      } catch (err) {
        return Promise.reject(err);
      }
    },
    carregarEmpresas(context) {
      try {
        publicAxios
          .get("/empresas")
          .then(response => context.commit("carregarEmpresas", response.data));

        return Promise.resolve(true);
      } catch (err) {
        return Promise.reject(err);
      }
    }
  }
};
